import { render } from "./Sidebar.vue?vue&type=template&id=48cf1419"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=48cf1419&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script